import AllRoute from "./Routes/AllRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <AllRoute />
      <ToastContainer />
    </>
  );
}

export default App;
